import PropTypes from 'prop-types';
import React from 'react';

import { isLocalURL } from '$utilities/browser';
import { formatLinkBlockToUrl } from '$utilities/format';
import { slugify } from '../../utilities/slugify.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleSpotlightBlock = ({
    body = null,
    heading = null,
    links = null,
    isAccordionOrSection,
}) => {
    return (
        <div className={`layout-container relative mt-40 mb-60 ${isAccordionOrSection ? 'md:my-60' : 'md:mt-60 md:mb-100'}`}>
            <div className='layout-grid-negative-gutter sm:flex'>
                <div className='hidden sm:block sm:w-4/12 md:w-5/12 layout-grid-col-padding' />

                <div className='w-12/12 sm:w-8/12 md:w-7/12 layout-grid-col-padding'>
                    <div className='bg-peach py-30 px-20 md:py-40 md:pl-40 md:pr-60'>
                        {heading && (
                            <h2 className='type-style-3 mb-20 md:mb-25'>
                                {heading}
                            </h2>
                        )}

                        {body && (
                            <p className='type-style-4 mb-25 md:mb-35'>
                                {body}
                            </p>
                        )}

                        <ul className='flex flex-wrap gap-10'>
                            {links?.map((link, idx) => {
                                const href = formatLinkBlockToUrl(link.link);
                                const target = isLocalURL(href) ? '_self' : '_blank';
                                const rel = isLocalURL(href) ? null : 'noreferrer noopener';

                                return (
                                    <li key={idx}>
                                        <a
                                            className={`pill-button pill-button--white gtm-${slugify(link.label)}`}
                                            href={href}
                                            rel={rel}
                                            target={target}>
                                            {link.label}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    body: PropTypes.string,
    heading: PropTypes.string,
    links: PropTypes.array,
    isAccordionOrSection: PropTypes.bool
};

ModuleSpotlightBlock.propTypes = propTypes;

export default ModuleSpotlightBlock;
